import { createEvent, restore, sample } from 'effector'

import { fx } from 'src/libs'
import { Offer, OfferRequest, OffersResponse } from './types'

export const offersListMounted = createEvent<OfferRequest>()

export const getOffers = fx<OfferRequest, OffersResponse>({
  method: 'GET',
  url: `/partner/material/offer`,
})

export const $offers = restore<Offer[]>(
  getOffers.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfOffers = restore(
  getOffers.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: offersListMounted,
  fn: ({ limit, page }) => {
    let query = {
      limit,
      page,
    }

    return {
      query,
    }
  },
  target: getOffers,
})
